import React from 'react'
import BootstrapAccordion from "react-bootstrap/Accordion";
import classNames from "classnames";
import { PieceMenuBody } from './PieceMenuBody'
import PropTypes from "prop-types";
import '../assets/css/LeftSearchMenuPiece.scss'

export const LeftSearchMenuPiece = ({ children, className, ...props }) => {
    const classes = classNames("uxf-accordion jdsn-facet", className);
    return (
        <BootstrapAccordion bsPrefix={" "} className={classes} {...props}>
            {children}
        </BootstrapAccordion>
    );
}

LeftSearchMenuPiece.propTypes = {
    as: PropTypes.elementType,

    activeKey: PropTypes.string,

    defaultActiveKey: PropTypes.string,
};

LeftSearchMenuPiece.Item = PieceMenuBody;

